'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdShopTwo = function MdShopTwo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 25l9.1-6.6-9.1-5v11.6z m0-20v3.4h6.6v-3.4h-6.6z m10 3.4h8.4v18.2c0 1.9-1.5 3.4-3.4 3.4h-23.4c-1.8 0-3.2-1.5-3.2-3.4v-18.2h8.2v-3.4c0-1.9 1.5-3.4 3.4-3.4h6.6c1.9 0 3.4 1.5 3.4 3.4v3.4z m-25 6.6v18.4h26.6c0 1.8-1.4 3.2-3.2 3.2h-23.4c-1.9 0-3.4-1.4-3.4-3.2v-18.4h3.4z' })
        )
    );
};

exports.default = MdShopTwo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/shop-two.js
// module id = 2774
// module chunks = 0